<block-ui [name]="'ajaxCall'" [delayStart]="0" [delayStop]="500" [message]="'Loading, please wait...'">
<router-outlet>
  
</router-outlet>
</block-ui>

<notifier-container></notifier-container>